<template>
  <!--可以用来做一些提示信息-->
  <a-space class="version" :size="10">
    <huasky-icon icon="TrademarkOutlined" style="font-size: 1.1em; font-weight: bold;" />
    <span style="margin-right: 20px;">API服务版本号：<strong>{{ state.api }}</strong></span>
    <span>收银台版本号：<strong>{{ state.cashier }}</strong></span>
  </a-space>
</template>
<script setup lang="ts">
import { getApiVersion, getCacherVersion } from '@src/scripts/api/store'
import { onMounted, reactive } from 'vue'

const state = reactive({
  api: '',
  cashier: ''
})

onMounted(async () => {
  const apiRes = await getApiVersion()
  const cashierRes = await getCacherVersion()
  state.api = apiRes.data
  state.cashier = cashierRes.data
})
</script>
<style lang="scss" scoped>
.version {
  font-size: .9em;
  padding-left: 15px;
}
</style>